import mobileStoreLocatorBanner from '@/shared/assets/images/locate-store/Mobile_Store_Locator.webp';
import desktopStoreLocatorBanner from '@/shared/assets/images/locate-store/Desktop_Store_Locator.webp';

type StoreHeroProps = {
  storeCount: number | null;
};

export function StoreHero({ storeCount }: StoreHeroProps) {
  const countLabel =
    typeof storeCount === 'number' && Number.isFinite(storeCount) ? storeCount : '350';

  return (
    <section className="relative w-full">
      <img
        src={mobileStoreLocatorBanner}
        alt="BlueStone store interior"
        className="h-[200px] w-full object-cover md:hidden"
      />
      <img
        src={desktopStoreLocatorBanner}
        alt="BlueStone store interior"
        className="hidden h-[280px] w-full object-cover md:block"
      />
      <div className="relative z-10 -mt-12 mx-4 mb-6 md:-mt-16 md:mx-auto md:mb-8 md:max-w-2xl">
        <div className="rounded-sm bg-white px-6 py-6 text-center shadow-md md:px-10 md:py-8">
          <div className="mb-3 flex items-center justify-center gap-3">
            <span className="h-px w-8 bg-[#d4a5b5] md:w-12" aria-hidden />
            <h1 className="font-serif text-lg font-semibold text-[#1a3a5c] md:text-2xl">
              Locate a BlueStone store near you
            </h1>
            <span className="h-px w-8 bg-[#d4a5b5] md:w-12" aria-hidden />
          </div>
          <p className="text-sm text-gray-600 md:text-base">
            Walk into one of our {countLabel} stores and discover a world of exquisite design.
          </p>
        </div>
      </div>
    </section>
  );
}
